module.exports = __webpack_public_path__ + "img/popup.325f6778.svg";